<template>
  <div>
    <b-modal
      :hide-header="true"
      :hide-footer="true"
      content-class="modal-blue"
      id="graduation-modal"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
      :hide-header-close="true"
      size="xl">
      <!-- Modal content -->
      <div class="row text-white content">

                    <div class="col-12">   {{$t('graduation.title')}}  </div>


                     <div class="col-12"> {{$t('graduation.buy')}} <input type="radio"  name="type" id="buy" class="radio" @click="chosenType('buy')"  />   </div>  
                     <div class="col-12"> {{$t('graduation.rent')}} <input type="radio"  name="type" id="rent" class="radio"  @click="chosenType('rent')"  />   </div>  




      </div>
    </b-modal>

  </div>
</template>

<script>
 import FinancialInfoResource from '../../api/financialInfoResource';
 const resource = new FinancialInfoResource();
export default {
            methods:{

                    chosenType(type){

                                if(confirm("ნამდვილად გსურთ არჩეული პასუხის შენახვა?/Are you sure you want to save the selected answer?")){

                                        this.$store.dispatch('auth/graduationAnswerSave',{chosenType:type}).then(response=>{

                                               window.location.href='/'


                                        })


                                }    


                    }


            }


   
};
</script>

<style scoped>
.radio{
 height: 20px;
  width: 20px;
    

}

</style>
 